import {
  createDefaultHosDataSavedAction,
  DEFAULT_HOS_DATA_SAVED,
} from "./../actions/defaultHosData";
import { ICompanyDefaultHosData } from "./../actions/defaultHosData";

export interface IDefaultHosData {
  [key: number]: Omit<ICompanyDefaultHosData, "companyId"> | undefined;
}

export const initialDefaultHosData: IDefaultHosData = {};

export const defaultHosDataReducer = (
  previousState: IDefaultHosData = initialDefaultHosData,
  action: ReturnType<typeof createDefaultHosDataSavedAction>
) => {
  switch (action.type) {
    case DEFAULT_HOS_DATA_SAVED:
      const { companyId, ...rest } = action.payload;
      if (!companyId) {
        return previousState;
      }

      return {
        ...previousState,
        [companyId]: { ...rest },
      };

    default:
      return previousState;
  }
};
